/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Not_AvailableInputs */

const en_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const fr_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const de_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N / A`)
};

const it_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N / A`)
};

const ru_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Н/Д`)
};

const es_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N / A`)
};

const zh_cn2_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不适用`)
};

const ja_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該当なし`)
};

const hi_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लागू नहीं`)
};

const pt_pt2_knp_guide_not_available = /** @type {(inputs: Knp_Guide_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N / D`)
};

/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Knp_Guide_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_not_available = /** @type {((inputs?: Knp_Guide_Not_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Not_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_not_available(inputs)
	if (locale === "de") return de_knp_guide_not_available(inputs)
	if (locale === "it") return it_knp_guide_not_available(inputs)
	if (locale === "ru") return ru_knp_guide_not_available(inputs)
	if (locale === "es") return es_knp_guide_not_available(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_not_available(inputs)
	if (locale === "ja") return ja_knp_guide_not_available(inputs)
	if (locale === "hi") return hi_knp_guide_not_available(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_not_available(inputs)
	return en_knp_guide_not_available(inputs)
});